import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";

import * as firebase from "firebase/app";

import "firebase/auth";
import "firebase/storage";

import './index.css';

import App from './App';

var firebaseConfig = {
  apiKey: "AIzaSyAfZeURoEHW_MNrY2MqKf6O9ip90jTJYR8",
  authDomain: "atibaiatv-366c3.firebaseapp.com",
  databaseURL: "https://atibaiatv-366c3.firebaseio.com",
  projectId: "atibaiatv",
  storageBucket: "atibaiatv.appspot.com",
  messagingSenderId: "489248461497",
  appId: "1:489248461497:web:a95518b349f8abeb510168",
  measurementId: "G-YVM33N1CC6"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <Router>
    <App firebase={firebase}/>
  </Router>, 
  document.getElementById('root')
);
